import { Skeleton } from '@/components/ui/skeleton'

export const NewIntegrationListSkeleton = () => {
	return (
		<div className="flex flex-col gap-4 pb-4">
			<div className="relative">
				<Skeleton className="h-9 w-full" />
			</div>

			<div className="mt-2">
				<div className="flex flex-col gap-6 md:flex-row md:gap-8">
					<aside className="md:w-56 md:shrink-0">
						<nav
							className="flex flex-col gap-2"
							aria-label="Integration categories"
						>
							{Array.from({ length: 8 }).map((_, index) => (
								<Skeleton className="h-9 w-full gap-2 px-3 py-2" key={index} />
							))}
						</nav>
					</aside>

					<div className="min-w-0 flex-1">
						<div className="flex flex-col gap-8">
							{/* Group Rows */}
							{Array.from({ length: 4 }).map((_, index) => (
								<section key={index}>
									<h3 className="text-muted-foreground mb-3 text-sm font-medium">
										<Skeleton className="h-6 w-32" />
									</h3>
									<div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
										{/* Cards */}
										{Array.from({ length: 4 }).map((_, indx) => (
											<Skeleton className="h-24 w-full" key={indx} />
										))}
									</div>
								</section>
							))}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
